<ng-container *ngIf="transactions$ | async as transactions">
  <div *ngFor="let day of transactions | keyvalue: keepOrder">
    <h5 class="transaction-date text-primary">{{ day.key }}</h5>
    <div class="card" *ngFor="let transaction of day.value">
      <div class="row h-100">
        <div class="col-8 text-start d-flex flex-column justify-content-between">
          <div class="fw-bold text-primary transaction-text font-size-14">
            {{ transaction.TransactionDescription }}
          </div>

          <div class="transaction-subtext text-info fw-bold font-size-12">
            {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
          </div>
        </div>
        <div class="col-4 text-end transaction-amount">
          <div
            class="fw-bold transaction-text text-capitalize font-size-12"
            [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
          >
            {{ transaction.Amount >= 0 ? '+' : ''
            }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!transactions || !hasTransactions">
    <div class="no-items w-100 text-center border rounded">
      <div class="svg ms-auto me-auto" fgbAnimateSvg>
        <img [src]="'placeholders/activity.svg' | contentAssetImage" alt="" />
      </div>
      <p class="text-black text-center font-size-14 mt-2 mb-0">
        {{ 'account.activity.placeholder.list.description' | translate }}
      </p>
    </div>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
